import { useEffect } from 'react'

interface SEOProps {
  title?: string
  description?: string
  image?: string
  url?: string
  type?: 'website' | 'article'
}

export default function SEO({ title, description, image, url, type = 'website' }: SEOProps) {
  const baseTitle = 'شليل للخدمات اللوجستية - Shalil Logistics'
  const baseDesc = 'خدمات لوجستية متكاملة - شحن بحري، جوي، وبري - تخليص جمركي - تخزين وتوزيع في جميع موانئ مصر'
  const siteUrl = 'https://shelil-logistics-services.pages.dev'
  const ogImage = image || `${siteUrl}/logo.png`

  useEffect(() => {
    document.title = title ? `${title} | ${baseTitle}` : baseTitle

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`)
      if (!el) {
        el = document.createElement('meta')
        el.setAttribute('name', name)
        document.head.appendChild(el)
      }
      el.setAttribute('content', content)
    }

    const setOg = (property: string, content: string) => {
      let el = document.querySelector(`meta[property="${property}"]`)
      if (!el) {
        el = document.createElement('meta')
        el.setAttribute('property', property)
        document.head.appendChild(el)
      }
      el.setAttribute('content', content)
    }

    setMeta('description', description || baseDesc)
    setMeta('keywords', 'خدمات لوجستية, شحن, شحن بحري, شحن جوي, شحن بري, تخليص جمركي, تخزين, توزيع, شليل, مصر, logistics, freight, shipping, customs')
    setMeta('robots', 'index, follow')
    setMeta('author', 'Shalil Logistics Services')
    setMeta('language', 'ar-EG')

    setOg('og:title', title ? `${title} | ${baseTitle}` : baseTitle)
    setOg('og:description', description || baseDesc)
    setOg('og:type', type)
    setOg('og:url', url || siteUrl)
    setOg('og:image', ogImage)
    setOg('og:image:width', '1200')
    setOg('og:image:height', '630')
    setOg('og:site_name', 'Shalil Logistics')
    setOg('og:locale', 'ar_EG')

    setMeta('twitter:card', 'summary_large_image')
    setMeta('twitter:title', title ? `${title} | ${baseTitle}` : baseTitle)
    setMeta('twitter:description', description || baseDesc)
    setMeta('twitter:image', ogImage)

    return () => {
      // cleanup not needed for meta tags on navigation in SPA
    }
  }, [title, description, image, url, type, ogImage])

  return null
}
